import React, { useEffect, useState } from 'react'
import classes from "./styles/testimonial.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AnubhaImg from "../../assets/testimonial/Anubha.png";
import DebashishImg from "../../assets/testimonial/Debashish.png";
import DeboshreeImg from "../../assets/testimonial/Deboshree.png";
import DikshaImg from "../../assets/testimonial/Diksha.jpg";
import PoorvajaImg from "../../assets/testimonial/Poorvaja.png";
import SagarikaImg from "../../assets/testimonial/Sagarika.png";
import ShayoriImg from "../../assets/testimonial/Shayori.png";
import ShraddhaImg from "../../assets/testimonial/Shraddha.jpg";
import ShrawaniImg from "../../assets/testimonial/Shrawani.jpeg";
import IshitaImg from "../../assets/testimonial/Ishita.jpeg";
import SubhamImg from "../../assets/testimonial/Subham.jpeg";
import VijayantImg from "../../assets/testimonial/Vijayant.jpeg";
import KnopalImg from "../../assets/testimonial/Knopal.jpeg";
import RadhaImg from "../../assets/testimonial/Radha.jpeg";
import ChhaviImg from "../../assets/testimonial/chhavi.png";
import AakanshaImg from "../../assets/testimonial/Aakansha.png";


import t1Img from "../../assets/transformation/t1.jpeg";
import t3Img from "../../assets/transformation/t3.jpeg";
import t4Img from "../../assets/transformation/t4.jpeg";
import t5Img from "../../assets/transformation/t5.jpeg";
import t6Img from "../../assets/transformation/t6.jpeg";
import t7Img from "../../assets/transformation/t7.jpeg";
import t8Img from "../../assets/transformation/t8.jpeg";
import t9Img from "../../assets/transformation/t9.jpeg";
import t11Img from "../../assets/transformation/t11.jpeg";
import t12Img from "../../assets/transformation/t12.jpeg";


const Testimonial = () => {
  const testiList = [
    {
        "imgUrl": ShayoriImg,
        "name": "Shayori",
        "location": "Delhi",
        "age": "28",
        "profession": "PR Professional",
        "summary": "I trained with Sushmita for about 6-8 months and noticed a clear difference in my strength and overall fitness. Her workouts were short, easy to follow, yet super effective. What I really appreciated was that each session felt suited to my goals, different and never boring or repetitive—so I always stayed engaged. <br/> She is easy to work with, always supportive, and really understood how to push just the right amount. <br/> Susmita's focus on body composition and discipline makes her training uniquely impactful."
    },
    {
        "imgUrl": SubhamImg,
        "name": "Shubham Upadhyay",
        "location": "Udaipur",
        "age": "40",
        "profession": "Government Banker",
        "summary": "I have been training with Susmita for last 5 years. What sets her apart from her peers is her focus on improving clients body composition i.e. focussing on body fats and muscles rather than age old marketing of weight loss or weight gain. <br/> Her methods are simple but demanding. She subconsciously instills discipline. <br/> As a nutritionist she is minute and gives you honest inputs on the foods one has consumed throughout the day. <br/> Best part of her training is that she listens to the client, understands their situation/work load/ emotional response to the training and modulates accordingly without deviating from the goal. <br/> Her philosophy of weight training is that muscles should bear the body weight as we grow old and body is able to function regular activities with ease. <br/> I wish her the very best for her future endeavours. She is my fitness asset. <br/> Post-pregnancy, Susmita’s practical and supportive training helped Radha regain confidence and strength."
    },
    {
        "imgUrl": RadhaImg,
        "name": "Radha Rinwa Upadhyay",
        "location": "Udaipur",
        "age": "36",
        "profession": "CA Aspirant",
        "summary": "Susmita is a wonderful human being. She comes more as a friend than a coach. However, she is a hard taskmaster during training, which eventually is expected from a trainer. <br/> I had joined her post pregnancy and she had beautifully understood my situation and concern. Her short but consistent training schedule helped me in gaining strength to cater to the needs of the newborn which further resulted in a confident physique post delivery of a child. <br/> Her approach is very practical and straight forward. This helps in gaining trust on the trainer. <br/> I have thoroughly enjoyed my sessions with her and she is my go to coach all the time . Wishing her the very best. <br/> Post-surgery, Susmita's patient training reignited strength, energy, and confidence."
    },
    {
        "imgUrl": DebashishImg,
        "name": "Debashish",
        "location": "Delhi",
        "age": "65",
        "profession": "Ex Foreign Embassy",
        "summary": "I don't know where to start as Sushmita is a Great motivator, a health instructor and a passionate health freak. My journey with her started in 2022. <br/> I had come back from surgery and was advised no workouts for at least a month. <br/> I have been a regular health freak myself but the surgery put me back a few years physically and also was not confident enough to start on my own. This is where Sushmita stepped in who also was training my daughter. We started slow as advised by the docs but gradually Sushmita with her patience and perseverance took me to a level which my many years of workout under different trainers didn't. <br/> The best part which I really find hard to believe is that a short period of workout( daily time )could bring about a sea of change. So thanks Sushmita for being there when I needed to you and increasing my energy levels, strength and endurance. <br/> Susmita turned a workout hater into someone who now finds joy and mental wellness in fitness."
    },
    {
        "imgUrl": KnopalImg,
        "name": "Konpal",
        "location": "Bangalore",
        "age": "31",
        "profession": "Startup",
        "summary": "I’ve always disliked working out—never felt good before, during, or after a session, which meant I was never consistent. But Susmita changed my entire outlook. She brings a truly personalized approach to training, adjusting the session based on how my energy is on that particular day. The workouts are effective and challenging, but never overwhelming. I don’t feel drained, but I still see real results. <br/> What really sets her apart is how holistic her approach is. Along with strength training, she shares incredibly helpful advice on nutrition that’s easy to follow and tailored to your goals. She also knows exactly when to encourage you—not too much, not too little. Somehow, we even end up laughing during workouts, which I never imagined was possible. It’s been a rare and refreshing mix of building strength, improving mental health, and actually enjoying the process. <br/> If you're considering strength training with a focus on both physical and mental well-being, I highly recommend working with Susmita. <br/> Didn’t think I’d ever say this—but fitness feels good now. You should absolutely go for it! <br/> Susmita’s personalized, functional fitness coaching is a life-enhancing partnership."
    },
    {
        "imgUrl": SagarikaImg,
        "name": "Sagorika Roy",
        "location": "Singapore",
        "age": "42",
        "profession": "Partner HR Consulting",
        "summary": "If you are seeking a fitness trainer who truly understands and caters to your unique interests and needs, look no further than Susmita Roy. Training online, Susmita offers a highly personalized approach that keeps every session engaging and motivating. <br/> What sets Susmita apart is their commitment to functional fitness—focusing not just on conventional fitness but on enhancing your overall quality of life. They meticulously tailor each workout plan to address specific areas of interest and ensure you achieve a balanced, healthier lifestyle. <br/> With Susmita, you are gaining more than a trainer; you are gaining a partner dedicated to your holistic well-being. They push the boundaries of conventional fitness paradigms, equipping you with the tools and mindset needed for long-term success. Highly recommended for anyone ready to embark on a transformative fitness journey. <br/> Fitness becomes fun and exciting with Susmita’s playful, caring training style."
    },
    {
        "imgUrl": VijayantImg,
        "name": "Vijayant Roy Khanna",
        "location": "Singapore",
        "age": "10",
        "profession": "Student",
        "summary": "Susmita is the best fitness trainer ever! She makes working out so much fun and always knows how to keep me excited. Every session, we do cool exercises that help me get stronger and healthier. She really cares about me and always makes sure I am doing my best. If you want to have a great time getting fit, Susmita is the one you should choose! <br/> Susmita's tailored, holistic coaching helped me grow stronger and more consistent over a year."
    },
    {
        "imgUrl": ChhaviImg,
        "name": "Chhavi",
        "location": "Bangalore",
        "age": "31",
        "profession": "VC Professional",
        "summary": "Training with Susmita for over a year has been a game-changer for my health and fitness. She takes a holistic approach that goes beyond just workouts—focusing on body, diet, and mindset, which has made all the difference for me. <br/> What I love most about her training style is that it’s completely personalized. She doesn’t rely on cookie-cutter plans but instead tailors every session to my strengths, weaknesses, and goals. Her focus is always on long-term functional fitness rather than quick fixes, which has helped me build sustainable progress. <br/> I started with 1kg, and now I’m lifting over 10kg! This progress wouldn’t have been possible without Susmita’s guidance and expertise. Training with her has truly been one of the best investments I’ve made for my health. <br/> Susmita’s passionate, personalized training led to transformation in both body and confidence."
    },
    {
        "imgUrl": AnubhaImg,
        "name": "Anubha",
        "location": "Bhopal",
        "age": "41",
        "profession": "School Principal",
        "summary": "Working with Sushmita has been a truly transformative experience for me. She is incredibly passionate, deeply involved, and genuinely committed to helping her clients achieve their fitness goals. What sets her apart is the way she guides each session with purpose, always pushing me to do better while ensuring the exercises suit my specific needs. Her knowledge of fitness and nutrition is impressive, and she has a natural ability to modify workouts to match individual capabilities without compromising on progress. I not only became stronger physically but also more confident and consistent, thanks to her dedicated support and expertise. <br/> During lockdown, Susmita brought sustainable structure, humor, and support."
    },
    {
        "imgUrl": PoorvajaImg,
        "name": "Poorvaja",
        "location": "Delhi",
        "age": "40",
        "profession": "Consultant",
        "summary": "Working with Susmita during the lockdown was a game-changer. She brought structure and motivation when everything felt uncertain. What makes her stand out is her simple, achievable approach—no drastic changes, just practical routines and personalized diet plans that fit into real life. Her guidance is realistic, sustainable, and tailored to your individual needs, which makes staying consistent so much easier. <br/> Beyond her expertise, Susmita’s personality is what truly makes the experience special. She talks to every client like a friend, making workouts feel fun and stress-free. Her sense of humor keeps you going even on the toughest days, and her genuine support keeps you committed. If you're looking for a coach who understands your lifestyle and makes fitness feel doable, Susmita is the one."
    },
    {
        "imgUrl": ShraddhaImg,
        "name": "Shraddha",
        "location": "Bhopal",
        "age": "54",
        "profession": "Musician & Lawyer",
        "summary": "Sushmita mam truly transformed my life. <br/> From daily stress, rising blood pressure, and vertigo issues — to a disciplined, healthier routine that now defines me, this journey has been nothing short of life-changing. Over the last three years, her daily involvement, follow-ups, and truly personalized care have gone far beyond a regular fitness coach. <br/> She’s not just a trainer; she’s a healer, a nutritionist, a guide — and for me, a lifeline. <br/> Whether it's customizing my health plans, correcting my mistakes with love and firmness, or simply believing in me when I didn’t — she’s shown up every single day. <br/> Even when I was a new mother with a small baby, Sushmita ma’am gave me confidence, space, and support without judgment. Her integrity, warmth, and consistency make her not just a coach, but a blessing. <br/> I feel lucky and proud to call myself one of her students."
    },
    {
        "imgUrl": DeboshreeImg,
        "name": "Deboshree",
        "location": "Delhi",
        "age": "32",
        "profession": "Social Development Professional",
        "summary": "Sushmita is a fantastic trainer and cant thank her enough for the incredible impact she’s had on my fitness journey. Her online classes are thoughtfully designed, keeping in mind each individual’s body type, needs, and fitness levels. It never feels like a one-size-fits-all approach—instead, it’s curated with real attention and care. <br/> What I love most is how focused the sessions are on core and strength training, all packed into just 25-30 minutes. It fits perfectly into my busy schedule without compromising on effectiveness. Each workout leaves me feeling stronger, more energized, and accomplished. <br/> Beyond just being an amazing trainer, she’s a truly wonderful human being and a dear friend. Her support, encouragement, and positive energy make all the difference. Training with her isn’t just about physical transformation—it’s a full mind-body experience with someone who genuinely cares. <br/> Highly recommend her to anyone looking to get fit in a smart and efficient way!"
    },
    {
        "imgUrl": DikshaImg,
        "name": "Diksha",
        "location": "Delhi",
        "age": "28",
        "profession": "Corporate Professional",
        "summary": "Sushmita has been more than just a trainer these past two years. With her guidance, I haven’t just lost weight—I’ve gained strength, confidence, and a mindset I never thought I could have. She has pushed me, encouraged me, and believed in me even on the days I didn’t believe in myself. I’m so grateful for this journey with her."
    },
    {
        "imgUrl": IshitaImg,
        "name": "Ishita",
        "location": "Bhopal",
        "age": "24",
        "profession": "PhD Scholar",
        "summary": "I’ve been training under Sushmita Ma’am for almost two years now, and it’s been an incredible journey of transformation — both physically and mentally. From the very beginning, she’s been more than just a gym instructor; she’s been a constant source of motivation, discipline, and positive energy. <br/> What sets her apart is her deep understanding of fitness and her ability to tailor workouts according to individual goals and limitations. Whether it was strength training, flexibility, or overall endurance, she made sure every session was well-planned and effective. Her guidance has helped me stay consistent, push my limits, and most importantly, enjoy the process. <br/> Sushmita Ma’am has played a huge role in making fitness a regular and rewarding part of my life, and I’m truly grateful for her dedication and support. If you're looking for someone who genuinely cares about your progress and brings the best out of you — she’s the one!"
    },
    {
        "imgUrl": ShrawaniImg,
        "name": "Shravani",
        "location": "Mumbai",
        "age": "26",
        "profession": "Corporate Lawyer",
        "summary": "Susmita Roy is not just your usual trainer - she goes beyond that and trains not only your body but also your mind. She is warm and kind, and encouraging and supportive throughout your fitness journey. She puts in a lot of effort into your growth and comes highly recommended. What sets her apart is that she is a dedicated trainer and nutritionist who provides guidance tailored to one’s individual requirement. Everyone deserves to have Susmita in their journey towards better health!"
    },
    {
        "imgUrl": AakanshaImg,
        "name": "Akanksha",
        "location": "Switzerland",
        "age": "40",
        "profession": "WEF",
        "summary": "Working with Susmita over the past year has truly changed my relationship with fitness and nutrition. She helped me become more mindful of what I eat—especially those mindless snacks like a random cookie I’d grab without thinking. When I started working out with her, I’d get dizzy doing even basic exercises, but with her guidance and encouragement, I’ve slowly built up my strength and can now pull weights I never imagined I could. I’m really grateful for the progress we’ve made together!"
    }
]


const Transformation = [ t1Img, t3Img, t4Img, t5Img, t6Img, t7Img, t8Img, t9Img, t11Img, t12Img];

    const settings = {
      dots: true,
      infinite: true,
      speed: 700,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false, 
      beforeChange: (current, next) => {
        if (current !== next) {
          setExpanded({});
        }
      },
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    };

    const transformationSettings = {
      dots: true,
      infinite: true,
      speed: 600,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true, 
      autoplaySpeed: 4000,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    };

  const [expanded, setExpanded] = useState({});
  const [charLimit, setCharLimit] = useState(425);

  const handleToggle = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const truncateSummary = (summary, index) => {
    const cleanText = summary.replace(/<br\s*\/?>/gi, ' ');
    if (cleanText.length <= charLimit || expanded[index]) return summary;

    const truncated = cleanText.slice(0, charLimit) + "...";
    return truncated;
  };

  useEffect(() => {
    const handleResize = () => {
      setCharLimit(window.innerWidth <= 768 ? 250 : 425);
    };
  
    handleResize(); // set on first render
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  

  return (
    <div className={classes.container}>
        <h2 className={classes.title}>Real People Real Results</h2>
      <div className={classes.mainCon}>
      <div className="slider-container">
        <Slider {...transformationSettings}>
        {Transformation.map((item, i) => {
          return <div key={i} className={classes.transormationCon}>
            <div className={classes.transforInnerCon}>
            <img src={item} alt='transformation'/>
            </div>
          </div>
        })}
        </Slider>
        </div>
        </div>

        <h2 className={classes.Secondtitle}>Testimonials</h2>
        <div className={classes.mainCon}>
      <div className="slider-container">
        <Slider {...settings}>
        {testiList.map((item, i) => {
              const showToggle = item.summary.replace(/<br\s*\/?>/gi, ' ').length > charLimit;
              const displaySummary = expanded[i]
                ? item.summary
                : truncateSummary(item.summary, i);

              return (
                <div key={i} className={`${classes.maindiv}`}>
                  <div className={classes.mainInnerDiv}>
                  <p className={classes.userSay}>
                    <span>&#x275D;</span>{" "}
                    <span
                      dangerouslySetInnerHTML={{
                        __html: displaySummary,
                      }}
                    />{" "}
                    {showToggle && (
                      <button
                        className={classes.seeMoreBtn}
                        onClick={() => handleToggle(i)}
                      >
                        {expanded[i] ? "See less" : "See more"}
                      </button>
                    )}
                    <span>&#x275E;</span>
                  </p>
                    <div className={classes.imgCon}>
                      <img src={item.imgUrl} alt="user-icon" loading="lazy" />
                    </div>
                    <h5 className={classes.name}>{item.name}, {item.age}</h5>
                    <p className={classes.location}>{item.profession}, {item.location}</p>
                  </div>
                </div>
              );
            })}
        </Slider>
        </div>
        </div>

    </div>
  )
}

export default Testimonial;
